import React, { useState } from 'react'
import { Button, Image, Modal } from 'react-bootstrap'
import ModalBody from 'react-bootstrap/ModalBody'
import ModalHeader from 'react-bootstrap/ModalHeader'
import ModalTitle from 'react-bootstrap/ModalTitle'
import { useTranslation } from 'react-i18next'
import closeimg from '../../../assets/images/close-blk.svg'
import QuizzesGridView from '../QuizzesGridView'

const CreateQuestionFromQuestionBank = (props: any) => {
  const { t } = useTranslation('translation')
  const [createQuizModal, setCreateQuizModal] = useState<
    'quiz' | 'roleplay' | undefined | null
  >(null)

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="modal-960"
    >
      <ModalHeader
        className="pt-4 justify-content-between"
        onHide={props.onHide}
      >
        <ModalTitle id="contained-modal-title-vcenter">
          <h2 className="mb-0">{t('Add from Question Bank')}</h2>
          {/* Sub title */}
          <p className="mb-0 font-sm">
            {t('Select the questions you would like to add to quiz.')}
          </p>
        </ModalTitle>
        <Button onClick={props.onHide}>
          <Image src={closeimg} />
        </Button>
      </ModalHeader>
      <ModalBody className="know-search-modalbody">
        <QuizzesGridView
          createFromQuestionBank
          quizId={props.quizId}
          addMoreQuestionToQuiz={props.addMoreQuestionToQuiz}
          createQuizModal={createQuizModal}
          setCreateQuizModal={setCreateQuizModal}
        />
      </ModalBody>
    </Modal>
  )
}

export default CreateQuestionFromQuestionBank
